import { parseISO, endOfMonth } from "date-fns";
import { fallbackDate } from "../config/dashboardDefaults";

export function getCustomerDashboardDate(customer) {
  const base = customer?.dashboard_date
    ? parseISO(customer.dashboard_date)
    : fallbackDate;

  const eom = endOfMonth(base);
  return new Date(eom.getFullYear(), eom.getMonth(), eom.getDate());
}